// // // import { reports, sectionMeta } from "../data/Knowledge";
// // // import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// // // /* AssochamReport.jsx
// // //    Listing page for Assocham's research reports.
// // //    Image banner + title hero; clickable banner cards open the
// // //    detail overview + download page (handled by the parent router). */
// // // export default function AssochamReport({ onOpen }) {
// // //   return (
// // //     <KnowledgeSection
// // //       section={sectionMeta.reports}
// // //       items={reports}
// // //       onOpen={onOpen}
// // //     />
// // //   );
// // // }



// // import { useNavigate } from "react-router-dom";
// // import { reports, sectionMeta } from "../data/Knowledge";
// // import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// // export default function AssochamReport() {
// //   const navigate = useNavigate();

// //   return (
// //     <KnowledgeSection
// //       section={sectionMeta.reports}
// //       items={reports}
// //       onOpen={(item) => navigate(`/knowledge/reports/${item.id}`)}
// //     />
// //   );
// // }





// // new code 




// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { sectionMeta } from "../data/Knowledge";
// import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// const REPORTS_API_URL = "https://www.assocham.org/api/reports-full.php";

// function useFetchList(url) {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     let cancelled = false;

//     fetch(url)
//       .then((res) => {
//         if (!res.ok) throw new Error("Network response was not ok");
//         return res.json();
//       })
//       .then((json) => {
//         if (cancelled) return;
//         if (json.success) {
//           setItems(json.data);
//         } else {
//           setError(json.message || "Failed to load data");
//         }
//       })
//       .catch(() => {
//         if (!cancelled) setError("Failed to load data");
//       })
//       .finally(() => {
//         if (!cancelled) setLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [url]);

//   return { items, loading, error };
// }

// export default function AssochamReport() {
//   const navigate = useNavigate();
//   const { items: reports, loading, error } = useFetchList(REPORTS_API_URL);

//   if (loading) return <div className="py-24 text-center text-mute">Loading reports...</div>;
//   if (error) return <div className="py-24 text-center text-red-600">{error}</div>;

//   return (
//     <KnowledgeSection
//       section={sectionMeta.reports}
//       items={reports}
//       onOpen={(item) => navigate(`/knowledge/reports/${item.id}`)}
//     />
//   );
// }






// new new code 



import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sectionMeta } from "../data/Knowledge";
import KnowledgeSection from "./KnowledgeSection";

const REPORTS_API_URL = "https://www.assocham.org/assocham_backend/api/reports-full.php";

function useFetchList(url) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((json) => {
        if (cancelled) return;
        if (json.success) {
          setItems(json.data);
        } else {
          setError(json.message || "Failed to load data");
        }
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load data");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { items, loading, error };
}

export default function AssochamReport() {
  const navigate = useNavigate();
  const { items: reports, loading, error } = useFetchList(REPORTS_API_URL);

  if (loading) return <div className="py-24 text-center text-mute">Loading reports...</div>;
  if (error) return <div className="py-24 text-center text-red-600">{error}</div>;

  return (
    <KnowledgeSection
      section={sectionMeta.reports}
      items={reports}
      // FIXED: previously it used item.id which is undefined in the API data.
      // The API returns "slug", and the detail page is at /knowledge/reports/:slug
      onOpen={(item) => navigate(`/knowledge/reports/${item.slug}`)}
    />
  );
}
